
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import ServicesSection from './components/ServicesSection';
import ValuePropositionSection from './components/ValuePropositionSection';
import TestimonialsSection from './components/TestimonialsSection';
import CTASection from './components/CTASection';
import HeroSectionV from './components/HeroSectionV';
import PortfolioSectionA from './components/PortfolioSectionA';

export default function Home() {
  return (
    <div className="min-h-screen bg-white dark:bg-slate-900 transition-colors duration-300">
      <Header />
      <main>
        <HeroSectionV />
        <ServicesSection />
        <PortfolioSectionA />
        <ValuePropositionSection />
        {/* <TestimonialsSection /> */}
        <CTASection />
      </main>
      <Footer />
    </div>
  );
}
